import { render, staticRenderFns } from "./exp-score.vue?vue&type=template&id=ebb3b5e8&scoped=true&"
import script from "./exp-score.vue?vue&type=script&lang=js&"
export * from "./exp-score.vue?vue&type=script&lang=js&"
import style0 from "./exp-score.vue?vue&type=style&index=0&id=ebb3b5e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb3b5e8",
  null
  
)

export default component.exports